import { useDispatch, useSelector } from 'react-redux'

import { FilterInput } from '@/components/form/Input'
import ReactSelect from '@/components/form/ReactSelect'
import { useText } from '@/components/i18n/hooks'
import { Translation } from '@/components/i18n/Translation'
import {
  getDevicePolicies,
  getDpFilter,
  getNumberOfPrices,
  getTextFilter,
  setDpFilter,
  setTextFilter,
} from '@/ducks/devicePolicyReducer'
import { numberFormat } from '@/util/formatters/numbers'

import './device-policy-price-list-filter.scss'

const DevicePolicyPriceListFilter = () => {
  const dispatch = useDispatch()

  const textFilter = useSelector(getTextFilter)
  const dpFilter = useSelector(getDpFilter)
  const devicePolicies = useSelector(getDevicePolicies)
  const numberOfResults = useSelector(getNumberOfPrices)

  const productFilterPlaceholderText = useText('filter products')

  const devicePolicyOptions = [
    {
      value: 0,
      label: <Translation id="All device policies" />,
    },
    // @ts-ignore
    ...devicePolicies.map(dp => ({
      value: dp.id,
      label: <DevicePolicyOption {...dp} />,
    })),
  ]

  return (
    <div className="device-policy-price-list-filter">
      <ReactSelect
        className="react-select"
        options={devicePolicyOptions}
        value={dpFilter}
        // @ts-ignore
        onChange={value => dispatch(setDpFilter(value))}
      />

      <FilterInput
        type="text"
        placeholder={productFilterPlaceholderText}
        value={textFilter}
        onChange={e => dispatch(setTextFilter(e.target.value))}
      />

      <div className="hits">
        <Translation id="Hits: {hits}" hits={numberFormat(numberOfResults)} />
      </div>
    </div>
  )
}

const DevicePolicyOption = ({ customerName, name }: any) => (
  <>
    <div className="customer-name">{customerName}</div>

    <div className="policy-name">{name}</div>
  </>
)

export default DevicePolicyPriceListFilter
